import './reviewBy.css';

function ReviewBy(props) {
  const { reviewImg, reviewBy, writtenBy, updateOn } = props;
  return (
    <div className="reviewBy">
      <div className="img_box">
        <img src={reviewImg} alt="reviewImg" />
      </div>
      <div className="review_detail">
        <p className="review_by"> {reviewBy || ''} </p>
        <p className="written_by"> {writtenBy || ''} </p>
        <p className="update_on"> {updateOn || ''} </p>
      </div>
    </div>
  );
}

export default ReviewBy;
